export default {
  dbl_filter_user_filter: 'User Filter',
  dbl_filter_user_filters_label: 'USER FILTERS',
  dbl_filter_user_filters: 'User Filters',
  dbl_filter_add_control_group: 'Add Control Group',
  dbl_filter_user_filter_setting: 'User Filter Setting',
  dbl_filter_add_new_filter: 'Add New Filter',
  dbl_filter_user_property: 'User Property',
  dbl_filter_conditions: 'Conditions',
  dbl_filter_value: 'Value',
  dbl_filter_number: 'Number',
  dbl_filter_please_select_user_property_first: 'Please select user property first',
  dbl_filter_filter_set_up: 'Filter Set up',
  dbl_filter_general_filter: 'Filter',
  dbl_filter_comparison: 'Comparison',
  dbl_filter_max_filters_reached: 'Add up to 5 filters',
  dbl_filter_user_filter_invalid: 'Please add the data source first.',
  dbl_filter_user_filter_effective: 'The user filter is not effective.The dataset lacks user attributes. Please contact v_blljli for help. ',
  dbl_filter_all_users_add: 'All users already exist, duplicate addition is not allowed',
  dbl_filter_add_control_group_disabled: 'Up to 4 control groups can be added',
  // Keys used in component
  dbl_filter_tab_current_filter: 'Filter',
  dbl_filter_tab_my_favorite: 'My Favorite',
  dbl_filter_complete_current_filter: 'Please complete current filter',
  dbl_filter_clear: 'Clear',
  dbl_filter_favorite: 'Favorite',
  dbl_filter_control_group_index: 'Control group {index}：',
  dbl_filter_collapse_expand_filter: 'Collapse/Expand Filter',
  dbl_filter_more_filter: 'More Filter',
  dbl_filter_collapse_filter: 'Collapse Filter',
  dbl_filter_collapse_expand_filter_tips: 'When enabled, filters will display in a single row by default. Click “More Filter” to expand the rest.',
  dbl_filter_filter_set_up_not_supported: 'Current game does not support filter setup.',
};
